// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1o3A4","col":"styles_col__2NCwd","fulfillmentStatus":"styles_fulfillmentStatus__2Vxh9","emailCol":"styles_emailCol__3tQJU"};